module.exports = __webpack_public_path__ + "img/PDM-600-Mobile-GIS1.d07e8732.png";